import React from "react";

export default function WinningMessage() {

  const styles = {
    margin: "1rem 0 0",
  };

  return (
    <div>
      <article 
        style={styles}
      >
        You Win! 🎉
      </article>
    </div>
  );
}